/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-continue */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope } from 'angular';
import moment from 'moment';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';
import { CustomTemplateModel } from '../../../src/app/shared/models/templates/custom';
import {
  BuildingBlock,
  BuildingBlockInput,
  BuildingBlockText,
  CustomTemplate,
} from '../../../src/app/@shared-types/print/custom';
import { EBuildingBlocks, EInputTypes, EPrintTemplates } from '../../../src/app/@shared-types/print/enums';
import { TabService } from '../../../shared/browser-functions/tab.service';
import { CustomTemplateRequest, TemplateForFrontend, TemplateRequest } from '../../../src/app/@shared-types/print/templates';
import { TemplateModel } from '../../../src/app/shared/models/templates/templates';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';
import { VehicleCheckResult } from '../../../src/app/@shared-types/vehicle/check';
import { Vehicle } from '../../../src/app/shared/models/vehicle/vehicle';
import { CO2_LABEL_TEMPLATE_ID, checkCo2LabelData } from './co2-label-check';

interface CustomTemplateScope extends IScope {
  sending: boolean,
  formLoading: boolean,
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  formTransmission: () => void,
  changeVat: () => void,
  onSelectTemplate: (input: unknown) => void,
  formReady: boolean,
  vehicle: AutoboardVehicle,
  customerId?: string,
  templateSelection: { [key: string]: string },
  selectedCustomTemplate: CustomTemplate | null,
  selectedTemplate: TemplateForFrontend | null,
  selection: {
    templateId: string,
    submitMode: 'Create' | 'Preview',
    templateType: 'Autoboard' | 'Tenant',
    onlineCheck: VehicleCheckResult | null,
  },
  blocks: {
    input: BuildingBlock[],
    pricesIncludeVat: boolean,
    text: BuildingBlock[],
  },
  showCustomerSelect: boolean,
  showVatSelect: boolean,
  switchTemplateType: () => void,
}

/* @ngInject */
export default function CustomTemplateFormController(
  $scope: CustomTemplateScope,
  customTemplateModel: CustomTemplateModel,
  tabService: TabService,
  templateModel: TemplateModel,
  toastService: ToastService,
  vehicle: Vehicle,
): void {
  let customTemplates: CustomTemplate[] = [];
  let templates: TemplateForFrontend[] = [];

  $scope.sending = false;
  $scope.formLoading = false;
  $scope.selectedCustomTemplate = null;
  $scope.selection = {
    templateId: '',
    submitMode: 'Create',
    templateType: 'Autoboard',
    onlineCheck: null,
  };

  $scope.templateSelection = {};
  $scope.formReady = false;
  $scope.blocks = {
    input: [],
    text: [],
    pricesIncludeVat: $scope.vehicle.vehicleData.price.includesVat || true,
  };
  $scope.showVatSelect = false;

  $scope.exitForm = () => {
    $scope.exit({ removeLock: true });
  };

  /** If one or more `PRICE` blocks are present in a template
   * we will show them in the form. We are combining the VAT attribute
   * for all of them. If the user changes the VAT selection, this method
   * will change the VAT on all PRICE block accordingly. */
  $scope.changeVat = (): void => {
    $scope.selectedCustomTemplate?.blocks
      // eslint-disable-next-line max-len
      .filter((b) => b.type === EBuildingBlocks.INPUT && (b as BuildingBlockInput).inputType === EInputTypes.PRICE)
      .forEach((b) => {
        (b as BuildingBlockInput).includesVat = $scope.blocks.pricesIncludeVat;
      });
  };

  /** User selected a `AutoboardTemplate`, we create a document from it and
   * download it. */
  const generateAutoboardDocument = async (): Promise<boolean> => {
    const req: TemplateRequest = {
      dummyVehicle: false,
      templateType: $scope.selection.templateId as EPrintTemplates,
      vehicleId: String($scope.vehicle._id),
    };

    return templateModel.createDocument(req)
      .then((res) => {
        const fileName = `${moment().format('YYYY-MM-DD')}.pdf`;
        tabService.downloadBlob(res as Buffer, fileName);

        return true;
      });
  };

  /** User wants a preview of the selected `CustomTemplate`.
   * We display the rendered HTML document in a new tab. */
  const generateCustomPreview = async (): Promise<boolean> => {
    if (!$scope.selectedCustomTemplate) throw new Error('Es wurde keine Vorlage ausgewählt.');

    const templateRequest: CustomTemplateRequest = {
      ...$scope.selectedCustomTemplate,
      dummyVehicle: false,
      templateType: EPrintTemplates.CUSTOM_TEMPLATE,
      vehicleId: String($scope.vehicle._id),
    };

    /** Fix for mongodb creating this mess */
    if (templateRequest.createTask === null) delete templateRequest.createTask;

    return customTemplateModel
      .createDocument(templateRequest, true)
      .then((res) => {
        const { html } = res as { html: string };
        tabService.openTabWithHTML(html, $scope.selectedCustomTemplate!.title, true);

        return false;
      });
  };

  /** User selected a `CustomTemplate`, we create a document from it
   * and download it. */
  const generateCustomDocument = async (): Promise<boolean> => {
    if (!$scope.selectedCustomTemplate) throw new Error('Es wurde keine Vorlage ausgewählt.');

    const templateRequest: CustomTemplateRequest = {
      ...$scope.selectedCustomTemplate,
      dummyVehicle: false,
      templateType: EPrintTemplates.CUSTOM_TEMPLATE,
      vehicleId: String($scope.vehicle._id),
    };

    /** Fix for mongodb creating this mess */
    if (templateRequest.createTask === null) delete templateRequest.createTask;

    return customTemplateModel
      .createDocument(templateRequest, false)
      .then((res) => {
        const fileName = `${moment().format('YYYY-MM-DD')}-${$scope.selectedCustomTemplate!.title.toLowerCase()}.pdf`;
        tabService.downloadBlob(res as Buffer, fileName);

        return true;
      });
  };

  $scope.formTransmission = async (): Promise<void> => {
    try {
      $scope.sending = true;
      let removeLock = false;

      if ($scope.selection.templateType === 'Autoboard') {
        removeLock = await generateAutoboardDocument();
      } else if ($scope.selection.submitMode === 'Create') {
        removeLock = await generateCustomDocument();
      } else {
        removeLock = await generateCustomPreview();
      }

      if (removeLock) $scope.exit({ removeLock: true });

      $scope.sending = false;
    } catch (e) {
      toastService.toast(ToastType.ERROR, 'Fehler beim Erstellen des Dokuments.');
    }
  };

  const removeConsecutiveTitleBlocks = (
    inputArray: BuildingBlock[],
  ): BuildingBlock[] => {
    const filteredArray: BuildingBlock[] = [];

    for (let i = 0; i < inputArray.length; i += 1) {
      const obj = inputArray[i];
      const nextObj = inputArray[i + 1];

      if ([EBuildingBlocks.TITLE].includes(obj.type)) {
        // If the current object is "TITLE" and
        // the next object is not "INPUT", skip the current "TITLE"
        if (nextObj && nextObj.type !== EBuildingBlocks.INPUT) {
          continue;
        }

        // If the current object is "TITLE" and the next object is
        // "INPUT", add the "TITLE" to the filtered array
        filteredArray.push(obj);
      } else {
        // For non-"TITLE" objects, add them directly to the filtered array
        filteredArray.push(obj);
      }
    }

    return filteredArray;
  };

  /** Add a `SPACER` block right before each `TITLE` block. */
  const addSpacers = (
    inputArray: BuildingBlock[],
  ): BuildingBlock[] => {
    const processedArray: BuildingBlock[] = [];

    for (let i = 0; i < inputArray.length; i += 1) {
      const currentObj = inputArray[i];
      processedArray.push(currentObj);

      if (currentObj.type === EBuildingBlocks.TITLE) {
        // Check if there is no SPACER object before the TITLE and add one if necessary
        if (i > 0 && inputArray[i - 1].type !== EBuildingBlocks.SPACER) {
          processedArray.splice(processedArray.length - 1, 0, { type: EBuildingBlocks.SPACER });
        }
      }
    }

    return processedArray;
  };

  /** User selects a template from the list. We then look for building blocks,
   * that need addtional information and prepare them to ask fot that. */
  $scope.onSelectTemplate = async (): Promise<void> => {
    // Dirty fix for change function being called before value is bound to ab-select's ng-model
    setTimeout(async () => {
      if ($scope.selection.templateType === 'Autoboard') {
        /** If the selected `AutoboardTemplate` requires an `OnlineCheck`
         * we do this here and display the results on top of the form. */
        const template = templates.find((t) => t.id === $scope.selection.templateId);

        if (!template) return;
        $scope.selectedTemplate = template;
        $scope.selection.onlineCheck = null;

        /** The Pkw-EnVKV label needs the full WLTP data set (not just the
         * relaxed advertising values), so we run a strict completeness check
         * and let the user see missing values before creating the document. */
        if (String(template.id) === CO2_LABEL_TEMPLATE_ID) {
          $scope.selection.onlineCheck = checkCo2LabelData($scope.vehicle);
          return;
        }

        if (template.onlineCheck) {
          $scope.selection.onlineCheck = await vehicle
            .onlineCheck(String($scope.vehicle._id), false, true);
        }

        return;
      }
      const template = customTemplates.find((t) => String(t._id) === $scope.selection.templateId);
      if (!template) return;
      $scope.selectedCustomTemplate = template;

      /** We move all blocks including the one's inside of `BuildingBlockColumn`
       * into one array to handle them easier. */
      const flattenedBlocks: BuildingBlock[] = [];
      template.blocks.forEach((b) => {
        if (b.type === EBuildingBlocks.COLUMN) return flattenedBlocks.push(...b.blocks);
        return flattenedBlocks.push(b);
      });

      $scope.blocks.input = flattenedBlocks.filter((b) => [
        EBuildingBlocks.INPUT, EBuildingBlocks.TITLE, EBuildingBlocks.INFO].includes(b.type));
      $scope.blocks.text = flattenedBlocks
        .filter((b) => [EBuildingBlocks.TEXT].includes(b.type))
        .filter((b) => (b as BuildingBlockText).customizable || !(b as BuildingBlockText).required);

      $scope.blocks.input = removeConsecutiveTitleBlocks($scope.blocks.input);
      $scope.blocks.input = addSpacers($scope.blocks.input);

      $scope.showVatSelect = $scope.blocks.input
        // eslint-disable-next-line max-len
        .some((b) => b.type === EBuildingBlocks.INPUT && (b as BuildingBlockInput).inputType === EInputTypes.PRICE);

      /** If one `BuildingBlockCustomer` is present,
       * we need to ask the user to select a `Customer` */
      $scope.showCustomerSelect = flattenedBlocks.some((b) => b.type === EBuildingBlocks.CUSTOMER);

      $scope.changeVat();
    }, 1);
  };

  /** Retreive all `CustomTemplate` from the server and display them
   * in a selection. */
  const init = async (): Promise<void> => {
    $scope.templateSelection = {};
    $scope.selection.onlineCheck = null;
    $scope.selection.templateId = '';

    $scope.formReady = false;

    if ($scope.selection.templateType === 'Autoboard') {
      templates = await templateModel.get();
      templates
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach((t) => {
          $scope.templateSelection[t.id] = t.name;
        });

      $scope.formReady = true;
      return;
    }

    customTemplates = await customTemplateModel.getAll();
    customTemplates
      .sort((a, b) => a.title.localeCompare(b.title))
      .forEach((t) => {
        $scope.templateSelection[String(t._id)] = t.title;
      });
    $scope.formReady = true;
  };

  $scope.switchTemplateType = (): void => {
    init();
  };

  init();
}
